import React from "react";
// import { __DATA__ } from "./data";

export default function App({data}) {
  const __DATA__ = (data || []).map(x => Object.assign({}, { distance: x.value, colors: x.svg.fill }));
  // const __DATA__ = [
  //   {
  //     distance: 13,
  //     colors: "#e0a106"
  //   },
  //   {
  //     distance: 20,
  //     colors: "#e0064e"
  //   },
  //   {
  //     distance: 16,
  //     colors: "#1da890"
  //   },
  //   {
  //     distance: 30,
  //     colors: "#7ca81d"
  //   },
  //   {
  //     distance: 22,
  //     colors: "#714511"
  //   }
  // ];

  return (
    <div className="barChartLabel">
      <div className="mainContainer">
        {__DATA__.map(({ distance, colors }, i) => {
          return (
            <div className="BarChartContainer" key={i}>
              <div className="number" style={{ color: colors }}>{distance}</div>
              <div className="chart" style={{ height: (distance * 2).toFixed(2) + '%', backgroundColor: colors }} />
            </div>
          );
        })}
      </div>
      <div className="" />
    </div>
  );
}
